export class EthnicGroup {
  Name: string;
  Language: string | null;
  Location: string | null;
  Action: string;
  Status: string;
  Workers: number;
  WorkersBenefitted: number;
  Churches: number;
  Believers: number;
  AmountPerWorker: number;
  Year: number;
  EthnicGroupID?: number;

  constructor(
    name: string,
    language: string | null,
    location: string | null,
    action: string,
    status: string,
    workers: number,
    workersBenefitted: number,
    churches: number,
    believers: number,
    amountPerWorker: number,
    year: number,
    ethnicGroupID?: number,
  ) {
    this.Name = name;
    this.Language = language;
    this.Location = location;
    this.Action = action;
    this.Status = status;
    this.Workers = workers;
    this.WorkersBenefitted = workersBenefitted;
    this.Churches = churches;
    this.Believers = believers;
    this.AmountPerWorker = amountPerWorker;
    this.Year = year;
    this.EthnicGroupID = ethnicGroupID;
  }
}
